import { Container } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import { useCarousal } from "../../Blc_Business/BlcHomeLandingPage/LandingPageBody";
import Pulse from 'react-reveal/Pulse';
import Zoom from 'react-reveal/Zoom';

const Hero_section = (props) => {
  const handleSelect = useCarousal();

  return (
    <Carousel
      fade
      activeIndex={handleSelect[0]}
      onSelect={(selectIndex, e) => handleSelect[1](selectIndex)}
      style={{ paddingBottom: '.5rem' }}
    >
      {props.heroVal.hero_carousalImg.map((data, idx) => (
        <Carousel.Item key={idx}>
          <img
            className="d-block w-100"
            src={data.hero_img.data[0].attributes.formats.large.url}
            alt="First slide"
          />

          <Carousel.Caption>
            <Container>
              <Pulse>
                <h4 className="mytagmain">{props.heroVal.welcomeText}</h4>
              </Pulse>
              <Zoom duration={1000}>
                <h4 className="mytagmaintwo">{data.hero_text}</h4>
              </Zoom>
            </Container>
          </Carousel.Caption>

        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export default Hero_section;
